(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function nextFrame(callback) {
    if (typeof window.requestAnimationFrame === "function") {
      return window.requestAnimationFrame(callback);
    }

    return window.setTimeout(callback, 16);
  }

  function initHeader() {
    var header = document.querySelector("[data-lowkey-header]");
    if (!header) return;

    var menuButton = header.querySelector("[data-lowkey-menu-toggle]");
    var mobileNav = header.querySelector("[data-lowkey-mobile-nav]");

    function syncScroll() {
      header.classList.toggle("is-scrolled", window.scrollY > 40);
    }

    syncScroll();
    window.addEventListener("scroll", syncScroll, { passive: true });

    if (menuButton && mobileNav) {
      menuButton.addEventListener("click", function () {
        var open = mobileNav.classList.toggle("is-open");
        menuButton.setAttribute("aria-expanded", open ? "true" : "false");
      });

      mobileNav.addEventListener("click", function (event) {
        if (event.target && event.target.closest && event.target.closest("a")) {
          mobileNav.classList.remove("is-open");
          menuButton.setAttribute("aria-expanded", "false");
        }
      });
    }
  }

  function initMotion() {
    if (prefersReducedMotion()) {
      document.documentElement.classList.add("lowkey-reduced-motion");
      document.querySelectorAll(".lowkey-reveal").forEach(function (element) {
        element.classList.add("is-visible");
      });
      return;
    }

    document.documentElement.classList.add("lowkey-motion-ready");

    var revealSelectors = [
      ".lowkey-reveal",
      ".lowkey-section-heading",
      ".lowkey-page-hero__content",
      ".lowkey-feature-card",
      ".lowkey-drop-card",
      ".lowkey-drops-showcase__lead",
      ".lowkey-meta-panel",
      ".lowkey-product-page__media",
      ".lowkey-product-page__info",
      ".lowkey-cart-item",
      ".lowkey-cart-summary",
      ".lowkey-empty",
      ".lowkey-contact-card",
      ".lowkey-resource-card",
      ".lowkey-collection-card",
      ".lowkey-blog-card"
    ];

    var revealItems = Array.prototype.slice.call(document.querySelectorAll(revealSelectors.join(",")));

    revealItems.forEach(function (element, index) {
      element.classList.add("lowkey-reveal");
      element.classList.add("lowkey-will-reveal");
      element.style.setProperty("--lowkey-reveal-delay", Math.min(index % 6, 5) * 70 + "ms");
    });

    var ticking = false;

    function syncReveal() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      revealItems.forEach(function (element) {
        if (element.classList.contains("is-visible")) return;

        var rect = element.getBoundingClientRect();
        if (rect.top < viewportHeight * 0.88 && rect.bottom > -80) {
          element.classList.add("is-visible");
        }
      });

      ticking = false;
    }

    function requestRevealSync() {
      if (ticking) return;
      ticking = true;
      nextFrame(syncReveal);
    }

    syncReveal();
    nextFrame(syncReveal);
    window.addEventListener("scroll", requestRevealSync, { passive: true });
    window.addEventListener("resize", requestRevealSync);
  }

  function initHeroMotion() {
    if (prefersReducedMotion()) return;

    var hero = document.querySelector(".lowkey-hero");
    if (!hero) return;

    var ticking = false;

    function syncHero() {
      var rect = hero.getBoundingClientRect();
      var progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      hero.style.setProperty("--lowkey-hero-y", (progress * 34).toFixed(2) + "px");
      ticking = false;
    }

    function requestSync() {
      if (ticking) return;
      ticking = true;
      nextFrame(syncHero);
    }

    syncHero();
    window.addEventListener("scroll", requestSync, { passive: true });
    window.addEventListener("resize", requestSync);
  }

  function initCartDrawer() {
    var root = document.querySelector("[data-lowkey-cart-drawer]");
    var cartLink = document.querySelector("[data-lowkey-cart-link]");
    if (!root || !cartLink) return;

    var dialog = root.querySelector("[data-lowkey-cart-dialog]");
    var itemsRoot = root.querySelector("[data-lowkey-cart-items]");
    var countRoot = root.querySelector("[data-lowkey-cart-count]");
    var subtotalRoot = root.querySelector("[data-lowkey-cart-subtotal]");
    var closeButtons = root.querySelectorAll("[data-lowkey-cart-close]");
    var shopLink = root.getAttribute("data-shop-url") || "/collections/all";

    function escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function formatMoney(cents) {
      var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "USD";
      try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: currency }).format((cents || 0) / 100);
      } catch (error) {
        return "$" + ((cents || 0) / 100).toFixed(2);
      }
    }

    function renderItem(item) {
      var image = item.image || root.getAttribute("data-placeholder") || "";
      var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";

      return [
        '<article class="lowkey-cart-drawer__item">',
          '<a class="lowkey-cart-drawer__image" href="' + escapeHtml(item.url) + '">',
            image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : "",
          "</a>",
          '<div class="lowkey-cart-drawer__item-content">',
            '<a class="lowkey-cart-drawer__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + "</a>",
            variant ? '<span class="lowkey-cart-drawer__variant">' + escapeHtml(variant) + "</span>" : "",
            '<span class="lowkey-cart-drawer__qty">Qty ' + escapeHtml(item.quantity) + "</span>",
          "</div>",
          '<strong class="lowkey-cart-drawer__price">' + escapeHtml(formatMoney(item.final_line_price)) + "</strong>",
        "</article>"
      ].join("");
    }

    function renderCart(cart) {
      if (countRoot) countRoot.textContent = cart.item_count + (cart.item_count === 1 ? " item" : " items");
      if (subtotalRoot) subtotalRoot.textContent = formatMoney(cart.total_price);

      if (!itemsRoot) return;

      if (!cart.items || !cart.items.length) {
        itemsRoot.innerHTML = [
          '<div class="lowkey-cart-drawer__empty">',
            "<p>Your bag is empty.</p>",
            '<a class="lowkey-button" href="' + escapeHtml(shopLink) + '">Shop the stock <span aria-hidden="true">&rarr;</span></a>',
          "</div>"
        ].join("");
        return;
      }

      itemsRoot.innerHTML = cart.items.map(renderItem).join("");
    }

    function fetchCart() {
      root.classList.add("is-loading");
      return fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart) renderCart(cart);
        })
        .finally(function () {
          root.classList.remove("is-loading");
        });
    }

    function openDrawer() {
      root.removeAttribute("hidden");
      nextFrame(function () {
        root.classList.add("is-open");
        cartLink.setAttribute("aria-expanded", "true");
        fetchCart();
      });
    }

    function closeDrawer() {
      root.classList.remove("is-open");
      cartLink.setAttribute("aria-expanded", "false");
      window.setTimeout(function () {
        if (!root.classList.contains("is-open")) {
          root.setAttribute("hidden", "");
        }
      }, 260);
    }

    cartLink.addEventListener("click", function (event) {
      if (window.location.pathname.indexOf("/cart") === 0) return;
      event.preventDefault();
      openDrawer();
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeDrawer);
    });

    root.addEventListener("click", function (event) {
      if (event.target === root) closeDrawer();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("is-open")) {
        closeDrawer();
      }
    });

    if (dialog) {
      dialog.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }
  }

  function initShelves() {
    document.querySelectorAll("[data-lowkey-shelf]").forEach(function (section) {
      var rail = section.querySelector("[data-lowkey-shelf-rail]");
      if (!rail) return;

      section.querySelectorAll("[data-lowkey-scroll]").forEach(function (button) {
        button.addEventListener("click", function () {
          var dir = button.getAttribute("data-lowkey-scroll") === "next" ? 1 : -1;
          rail.scrollBy({ left: dir * 360, behavior: "smooth" });
        });
      });
    });
  }

  function initBackgroundAudio() {
    var root = document.querySelector("[data-lowkey-audio-player]");
    if (!root) return;

    var audio = root.querySelector("[data-lowkey-audio]");
    var button = root.querySelector("[data-lowkey-audio-toggle]");
    var label = root.querySelector("[data-lowkey-audio-label]");

    if (!audio || !button) return;

    audio.volume = 0.42;

    function setState(isPlaying) {
      var action = isPlaying ? "Pause background music" : "Play background music";
      root.classList.toggle("is-playing", isPlaying);
      button.setAttribute("aria-pressed", isPlaying ? "true" : "false");
      button.setAttribute("aria-label", action);
      button.setAttribute("title", action);
      if (label) label.textContent = action;
    }

    function playAudio() {
      var playPromise = audio.play();

      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(function () {
            setState(true);
          })
          .catch(function () {
            setState(false);
          });
      } else {
        setState(true);
      }
    }

    function pauseAudio() {
      audio.pause();
      setState(false);
    }

    function removeFirstInteractionListeners() {
      window.removeEventListener("pointerdown", playOnFirstInteraction);
      window.removeEventListener("touchstart", playOnFirstInteraction);
      window.removeEventListener("keydown", playOnFirstInteraction);
    }

    function playOnFirstInteraction(event) {
      removeFirstInteractionListeners();

      if (event.target && root.contains(event.target)) {
        return;
      }

      if (audio.paused) {
        playAudio();
      }
    }

    button.addEventListener("click", function () {
      if (audio.paused) {
        playAudio();
      } else {
        pauseAudio();
      }
    });

    audio.addEventListener("ended", function () {
      setState(false);
    });

    window.addEventListener("pointerdown", playOnFirstInteraction, { passive: true });
    window.addEventListener("touchstart", playOnFirstInteraction, { passive: true });
    window.addEventListener("keydown", playOnFirstInteraction);
  }

  function initRecentlyViewed() {
    var sections = document.querySelectorAll("[data-lowkey-recently-viewed]");
    if (!sections.length) return;

    var storageKey = "lowkey_recently_viewed";

    function readHandles() {
      try {
        var parsed = JSON.parse(window.localStorage.getItem(storageKey) || "[]");
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch (error) {
        return [];
      }
    }

    function writeHandles(handles) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(handles.slice(0, 12)));
      } catch (error) {
        return;
      }
    }

    function normalizeImage(src) {
      if (!src) return "";
      if (src.indexOf("//") === 0) return window.location.protocol + src;
      return src;
    }

    function escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function formatMoney(cents) {
      var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "USD";
      try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: currency }).format((cents || 0) / 100);
      } catch (error) {
        return "$" + ((cents || 0) / 100).toFixed(2);
      }
    }

    function renderProduct(product, placeholder) {
      var variant = product.variants && product.variants.length ? product.variants[0] : null;
      var image = normalizeImage(product.featured_image) || placeholder;
      var available = variant ? variant.available : product.available;
      var category = product.type || product.vendor || "";
      var price = variant ? variant.price : product.price;
      var badge = available ? category : "Sold out";
      var quickLabel = available ? "Quick add" : "Sold out";
      var disabled = available ? "" : " disabled";

      return [
        '<article class="lowkey-product-card lowkey-card lowkey-reveal">',
          '<a class="lowkey-product-card__link" href="' + escapeHtml(product.url) + '">',
            '<span class="lowkey-product-card__media">',
              '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="720" height="900">',
            "</span>",
            badge ? '<span class="lowkey-product-card__badges"><span>' + escapeHtml(badge) + "</span></span>" : "",
            '<span class="lowkey-product-card__content">',
              category ? '<span class="lowkey-product-card__category">' + escapeHtml(category) + "</span>" : "",
              "<strong>" + escapeHtml(product.title) + "</strong>",
              '<span class="lowkey-product-card__price">' + escapeHtml(formatMoney(price)) + "</span>",
            "</span>",
          "</a>",
          variant ? '<form class="lowkey-product-card__form" method="post" action="/cart/add"><input type="hidden" name="id" value="' + escapeHtml(variant.id) + '"><button class="lowkey-product-card__quick" type="submit"' + disabled + ">" + quickLabel + "</button></form>" : "",
        "</article>"
      ].join("");
    }

    sections.forEach(function (section) {
      var currentHandle = section.getAttribute("data-current-product-handle");
      var limit = parseInt(section.getAttribute("data-product-limit"), 10) || 4;
      var placeholder = section.getAttribute("data-placeholder") || "";
      var handles = readHandles();

      if (currentHandle) {
        handles = [currentHandle].concat(handles.filter(function (handle) { return handle !== currentHandle; }));
        writeHandles(handles);
      }

      var recentHandles = handles.filter(function (handle) { return handle && handle !== currentHandle; }).slice(0, limit);
      if (!recentHandles.length) return;

      Promise.all(recentHandles.map(function (handle) {
        return fetch("/products/" + encodeURIComponent(handle) + ".js")
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;

        var grid = section.querySelector("[data-lowkey-recently-viewed-grid]");
        if (grid) {
          grid.innerHTML = products.map(function (recentProduct) {
            return renderProduct(recentProduct, placeholder);
          }).join("");
          grid.querySelectorAll(".lowkey-reveal").forEach(function (element) {
            element.classList.add("is-visible");
          });
        }
      });
    });
  }

  function init() {
    initHeader();
    initMotion();
    initHeroMotion();
    initCartDrawer();
    initShelves();
    initBackgroundAudio();
    initRecentlyViewed();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
